// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input__input-container {
  position: relative;
}
.Input__placeholder-label {
  position: absolute;
  top: 18px;
  left: 14px;
  transform: translateY(0);
  transition: all 0.3s ease;
  pointer-events: none;
  opacity: 0.5;
  color: #8c8c8c;
  font-family: Outfit;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
}
.Input__focused .Input__placeholder-label, .Input__InputField:not(:placeholder-shown) + .Input__placeholder-label {
  top: -10px; /* Move label up to top of input */
  transform: translateY(0);
  opacity: 1;
  background: white;
  padding: 4px;
  color: #1e1e1e;
  font-family: Outfit;
  font-size: 12px;
  font-weight: 300;
  line-height: 15px;
  letter-spacing: 0em;
}
.Input__InputField {
  outline: none;
  width: 100%;
  height: 56px;
  padding: 10px 16px 10px 16px;
  border-radius: 12px;
  border: 1px solid #d9d9d9;
}
.Input__InputField:focus {
  border-color: #00aa74;
  box-shadow: 0 0 5px #00aa74;
}
.Input__InputField:not(:placeholder-shown) {
  color: #333333;
  font-family: Outfit;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/Input/input.scss"],"names":[],"mappings":"AAGI;EACI,kBAAA;AAFR;AAII;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAFR;AAII;EAEI,UAAA,EAAA,kCAAA;EACA,wBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAHR;AAKI;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;AAHR;AAMI;EACI,qBAAA;EACA,2BAAA;AAJR;AAMI;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAJR","sourcesContent":["@import '../../../Styles/sass//variables';\n\n.Input {\n    &__input-container {\n        position: relative;\n    }\n    &__placeholder-label {\n        position: absolute;\n        top: 18px;\n        left: 14px;\n        transform: translateY(0);\n        transition: all 0.3s ease;\n        pointer-events: none;\n        opacity: 0.5;\n        color: #8c8c8c;\n        font-family: Outfit;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 20px;\n        letter-spacing: 0em;\n        text-align: left;\n    }\n    &__focused &__placeholder-label,\n    &__InputField:not(:placeholder-shown) + &__placeholder-label {\n        top: -10px; /* Move label up to top of input */\n        transform: translateY(0);\n        opacity: 1;\n        background: white;\n        padding: 4px;\n        color: #1e1e1e;\n        font-family: Outfit;\n        font-size: 12px;\n        font-weight: 300;\n        line-height: 15px;\n        letter-spacing: 0em;\n    }\n    &__InputField {\n        outline: none;\n        width: 100%;\n        height: 56px;\n        padding: 10px 16px 10px 16px;\n        border-radius: 12px;\n        border: 1px solid #d9d9d9;\n    }\n\n    &__InputField:focus {\n        border-color: #00aa74;\n        box-shadow: 0 0 5px #00aa74;\n    }\n    &__InputField:not(:placeholder-shown) {\n        color: #333333;\n        font-family: Outfit;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 20px;\n        letter-spacing: 0em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
